import Button from '../../../components/Button/Button';
import DialogModal from '../../../components/DialogModal/DialogModal';
import MaxWidth from '../../../components/MaxWidth/MaxWidth';
import Paragraph from '../../../components/Paragraph/Paragraph';
import Row from '../../../components/Row/Row';
import SVG from '../../../components/SVG/SVG';
import Stack from '../../../components/Stack/Stack';
import Title from '../../../components/Title/Title';
import useDismissableProp from '../../../hooks/react/useDismissableProp';
import useTrans from '../../../hooks/ui/useTrans';

import warningIcon from './graphics/warning.svg?raw';

import styles from './PaymentErrorDialog.module.css';

type PaymentErrorDialogProps = {
    paymentError?: string;
};

const PaymentErrorDialog = ({ paymentError }: PaymentErrorDialogProps) => {
    const trans = useTrans('CustomerArea.Shared.PaymentErrorDialog.');
    const error = useDismissableProp({ prop: paymentError }, [paymentError]);

    if (!error.value) {
        return null;
    }

    return (
        <DialogModal onCloseRequested={error.dismiss} isOpen>
            <Stack space="large">
                <Row horizontal="center">
                    <SVG src={warningIcon} className={styles.Icon} />
                </Row>

                <Stack>
                    <Title variant="page" align="center">
                        {trans('Title')}
                    </Title>

                    <Row horizontal="center">
                        <MaxWidth width={300}>
                            <Paragraph align="center">{error.value}</Paragraph>
                        </MaxWidth>
                    </Row>
                </Stack>

                <Row horizontal="center">
                    <Button onClick={error.dismiss} size="large">
                        {trans('RetryButtonLabel')}
                    </Button>
                </Row>
            </Stack>
        </DialogModal>
    );
};

export default PaymentErrorDialog;
